import React from 'react'
import { Flex, Button } from '@workwhile/ui'
import { GeneralDetails } from './GeneralDetails'
import { Link } from 'react-router-dom'
import { useDayforceJobContextValue } from 'pages/Dayforce/shared/context/DayforceJobProvider'
import { useDayforceAgenciesContextValue } from 'pages/Dayforce/shared/context/DayforceAgenciesProvider'
import { BookingDetails } from '../../BookingDetails/BookingDetails'

export const JobDetailsMain = () => {
  const {
    state: { agencies },
  } = useDayforceAgenciesContextValue()
  const {
    state: { data },
  } = useDayforceJobContextValue()

  const agency = agencies[data.agencyId]

  return (
    <Flex flexDirection="column" gap={3}>
      <GeneralDetails
        actionsBlock={
          <>
            {agency?.dayforceBaseUrl ? (
              <Button
                as={Link}
                to={`${agency?.dayforceBaseUrl}/jobs/${data.jobId}`}
                variant="secondary"
                target="_blank"
                rel="noopener noreferrer"
              >
                View job in Dayforce
              </Button>
            ) : null}
          </>
        }
      />
      {data.bookings.map((booking, index) => (
        <BookingDetails
          bookingId={booking.bookingId}
          bookingIdx={index}
          key={booking.bookingId}
        />
      ))}
    </Flex>
  )
}
